import { useCallback } from 'react';
import { ChatWidget } from '@cx3/sdk';
import { CHAT_CONFIG, resolveUser } from '@/lib/chat';
import { useAuth } from '@/hooks/use-auth';

/**
 * Simplified chat component for use during video/voice calls
 * Embeds in the sidebar panel
 */
export default function InCallChat({ recipientId, recipientName }) {
  const { astrologer } = useAuth();

  // Token fetcher
  const getToken = useCallback(async () => {
    if (!astrologer?.accessToken) throw new Error('Not authenticated');
    
    const response = await fetch(`${import.meta.env.VITE_BACKEND_URL}/api/chat/token/astrologer`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${astrologer.accessToken}`,
      },
    });
    
    if (!response.ok) {
      throw new Error('Failed to get chat token');
    }
    
    const data = await response.json();
    return data.data.token;
  }, [astrologer?.accessToken]);

  if (!astrologer?.astrologerId) {
    return <p className="text-gray-600 text-sm">Chat unavailable</p>;
  }

  const chatConfig = {
    serverUrl: CHAT_CONFIG.serverUrl,
    tenantId: CHAT_CONFIG.tenantId,
    userId: `astro_${astrologer.astrologerId}`,
    userRole: 'provider',
    recipientId,
    getToken,
    resolveUser,
  };

  return (
    <div className="h-64 flex flex-col">
      <ChatWidget
        config={chatConfig}
        showConnectionStatus={false}
        showTypingIndicator={true}
        showReadReceipts={false}
        showOnlineStatus={false}
        placeholder="Send a message..."
        className="flex-1"
        style={{
          border: 'none',
          borderRadius: '8px',
          fontSize: '14px',
        }}
        emptyState={
          <div className="text-center py-4 text-gray-500 text-sm">
            Send a message to {recipientName || 'the user'}
          </div>
        }
      />
    </div>
  );
}
